import { useEffect } from 'react'
import { useQuery } from '@tanstack/react-query'
import { useToast } from '@/view/components/ui/use-toast'
import { crefazService } from '../services/crefazService'

export const useMaritalStatus = () => {
  const { isError, isFetching, isLoading, data } = useQuery({
    queryKey: ['maritalStatus'],
    queryFn: crefazService.getMaritalStatus,
  })

  const { toast } = useToast()

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregar o estado civil, tente novamente mais tarde!',
      })
    }
  }, [isError, toast])

  return {
    isFetching,
    isLoading,
    data,
  }
}
